"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.keysCamelToSnake = void 0;

var _mapKeys = _interopRequireDefault(require("lodash/mapKeys"));

var _stringUtils = require("@eb/string-utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Uses our specific camelToSnake instead of _.snakeCase
 * this is because lodash makes event.destination => event_destination
 */
var keysCamelToSnake = function keysCamelToSnake(obj) {
  return (0, _mapKeys.default)(obj, function (value, key) {
    return (0, _stringUtils.camelToSnake)(key);
  });
};

exports.keysCamelToSnake = keysCamelToSnake;
//# sourceMappingURL=keysCamelToSnake.js.map